<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<main class="main-bg">
    <app-fc-calc-section
        [selectedLanguage]="selectedLanguage"
        (filterProducts)="filterProducts($event)"
    ></app-fc-calc-section>

    <div class="tw-max-w-[1240px] tw-px-4 xl:tw-px-0 tw-mx-auto tw-pt-[50px]">
        <ng-container *ngIf="filteredProducts.length > 0">
            <h2 class="!tw-text-center md:!tw-text-left !tw-font-bold">
                {{ filteredProducts.length || 0 }}
                {{ "FINANCING_CALCULATOR.LIST" | translate }}
            </h2>
            <p class="!tw-text-center md:!tw-text-left">
                {{ "FINANCING_CALCULATOR.LIST_NOTE" | translate }}
            </p>
        </ng-container>
        <p
            class="tw-max-w-[920px] !tw-mx-auto !tw-text-[#003A70] !tw-text-[22px] !tw-font-semibold"
            *ngIf="filteredProducts.length === 0"
        >
            {{ "FINANCING_CALCULATOR.NOT_FOUND" | translate }}
        </p>
        <div
            *ngIf="prodToDisplay.length > 0"
            class="card-section tw-hidden sm:tw-grid lg:tw-py-12 tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4 bg-white"
        >
            <app-finance-product-card
                *ngFor="let product of prodToDisplay"
                [product]="product"
                [filter]="filter"
                [selectedLanguage]="selectedLanguage"
            ></app-finance-product-card>
        </div>
        <!-- Mobile View Carousel -->
        <div
            *ngIf="filteredProducts.length > 0"
            class="sm:tw-hidden tw-relative tw-overflow-hidden tw-py-6"
        >
            <!-- Slides Container -->
            <div
                class="tw-flex tw-transition-transform tw-duration-300"
                [style.transform]="'translateX(-' + currentSlide * 100 + '%)'"
            >
                <div
                    *ngFor="let slide of mobileSlides"
                    class="tw-min-w-full tw-grid tw-grid-cols-2 tw-gap-4"
                >
                    <app-finance-product-card
                        *ngFor="let product of slide"
                        [product]="product"
                        [filter]="filter"
                        [selectedLanguage]="selectedLanguage"
                    ></app-finance-product-card>
                </div>
            </div>

            <!-- Left Arrow -->
            <button
                class="tw-absolute tw-top-1/2 tw-left-0 -tw-translate-y-1/2 tw-border tw-h-[50px] tw-w-[50px] tw-bg-white tw-border-[#4B6EEC] tw-rounded-full tw-shadow tw-p-2 tw-z-10"
                (click)="prevSlide()"
                [disabled]="currentSlide === 0"
            >
                <mat-icon class="tw-text-[#4B6EEC] tw-text-xl"
                    >chevron_left</mat-icon
                >
            </button>

            <!-- Right Arrow -->
            <button
                class="tw-absolute tw-top-1/2 tw-right-0 -tw-translate-y-1/2 tw-border tw-h-[50px] tw-w-[50px] tw-bg-white tw-border-[#4B6EEC] tw-rounded-full tw-shadow tw-p-2 tw-z-10"
                (click)="nextSlide()"
                [disabled]="currentSlide === mobileSlides.length - 1"
            >
                <mat-icon class="tw-text-[#4B6EEC] tw-text-xl"
                    >chevron_right</mat-icon
                >
            </button>
        </div>

        <button
            *ngIf="
                filteredProducts.length > 8 &&
                filteredProducts.length > prodToDisplay.length
            "
            ga-event-id="show_more_button_financing_calculator_click"
            ga-event-category="Financing Calculator Button"
            ga-event-label="Show More Button Click"
            ga-track="track"
            (click)="showMoreProducts()"
            class="tw-hidden sm:tw-flex tw-items-center tw-mx-auto tw-my-5 tw-text-[#003A70] tw-border tw-border-[#003A70] tw-px-[50px] tw-py-2 tw-rounded-full"
        >
            {{ "NEW_PRODUCTS.SHOW_MORE_PRODUCTS" | translate }}
            <mat-icon class="tw-ml-2">expand_more</mat-icon>
        </button>
    </div>

    <app-finance-explore></app-finance-explore>
    <app-fc-benefits [selectedLanguage]="selectedLanguage"></app-fc-benefits>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
